module.exports = __webpack_public_path__ + "static/media/Rain.3881ed65.jpg";